import {
  QQ,
  ResponseError,
  Team,
  TeamDetailed,
  TeamMemberProfile as TeamMember,
  TeamOwned,
  TeamPaged,
  UserProfile,
  UserProfileTeam
} from './models'

import axios from 'axios'
import store from './store'
import router from './router'

const instance = axios.create({
  baseURL: '/2021/',
  withCredentials: true,
  responseType: 'json'
})
instance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response) {
      const response: ResponseError = error.response.data
      return Promise.reject(response.details ?? response.error)
    } else if (error.request) {
      return Promise.reject('请求错误')
    } else {
      return Promise.reject(error.message)
    }
  }
)

function biluochun(...path: string[]) {
  return path.join('/')
}

export function login() {
  // window.removeEventListener('message', receiveMessage)
  // // https://stackoverflow.com/a/34905299
  // const w = 600
  // const h = 700
  // const y = window.outerHeight / 2 + window.screenY - h / 2
  // const x = window.outerWidth / 2 + window.screenX - w / 2
  // window.open(
  //   biluochun('/api/login/azure'),
  //   'MicrosoftOAuthWindow',
  //   `menubar=no, toolbar=no, width=${w}, height=${h}, top=${y}, left=${x}`
  // )
  // window.addEventListener('message', receiveMessage)
}

// function receiveMessage(event: MessageEvent) {
//   if (event.origin !== BILUOCHUN_ROOT) return
//   const { data: profile } = event
//   store.commit('setUser', profile)
//   if (!profile.team) {
//     router.push('/team/new')
//   }
// }

/// GET /
export async function isAlive(): Promise<boolean> {
  return true
}

/// GET /api/team/
export async function getTeamsList(): Promise<Team[]> {
  const response = await instance.get(`/team.json`)
  return response.data
}

/// GET /api/team/?page=<current>
export async function getTeamsPage(current: number, size: number): Promise<TeamPaged> {
  const teams = (await instance.get('/team.json')).data as TeamDetailed[]
  for (const team of teams) {
    team.members = await getTeamMembers(team.id)
  }
  const total = teams.length
  const last = Math.ceil(total / size)
  let ret: TeamPaged = {
    current,
    first: 1,
    last,
    next: current < last ? current + 1 : null,
    prev: current > 1 ? current - 1 : null,
    teams: teams.slice((current - 1) * size, current * size)
  }
  return ret
}

/// GET /api/team/<team_id>
export async function getTeamInfo(teamId: number): Promise<TeamDetailed> {
  const teams = (await instance.get('/team.json')).data as TeamDetailed[]
  return teams.filter((t) => t.id === teamId)[0]
}

/// GET /api/team/<team_id>/members
export async function getTeamMembers(teamId: number): Promise<TeamMember[]> {
  const members = (await (await instance.get('/member.json')).data) as Record<string, TeamMember[]>
  return members[teamId.toString()] || []
}

/// TODO: POST /api/team/<team_id>/members

/// GET /api/team/<team_id>/avatar
export function teamAvatarUrl(teamId: number): string {
  return '/2021/biluochun-img/team/' + String(teamId)
}

/// GET /api/users/<user_id>
export async function getUserProfile(userId: number): Promise<UserProfile> {
  const users = (await (await instance.get('/user.json')).data) as UserProfile[]
  return users.filter((u) => u.id === userId)[0]
}

/// GET /api/profile/
export async function getSelfProfile(): Promise<UserProfileTeam> {
  const response = await instance.get(`/api/profile/`)
  return response.data
}

/// GET /api/profile/team
export async function getSelfTeam(): Promise<TeamOwned> {
  const response = await instance.get(`/api/profile/team`)
  return response.data
}

/// POST /api/profile/team
export async function joinTeam(inviteCode: string): Promise<undefined> {
  const form = new FormData()
  form.append('invite_code', inviteCode)
  await instance.post(`/api/profile/team`, form)
  return
}

/// DELETE /api/profile/team
export async function leaveTeam(): Promise<undefined> {
  await instance.delete(`/api/profile/team`)
  return
}

/// GET /api/profile/avatar/
export function userAvatarUrl(userId?: number): string {
  if (userId) {
    return '/2021/biluochun-img/user/' + String(userId)
  } else {
    return '/2021/biluochun-img/1'
  }
}

/// POST /api/profile/avatar/
/// POST /api/team/<team_id>/avatar
export function updateAvatarUrl(teamId?: number) {
  if (teamId) {
    return biluochun(`/api/team/${teamId}/avatar`)
  } else {
    return biluochun(`/api/profile/avatar`)
  }
}

/// POST /api/profile/
export async function updateProfile(name: string) {
  const form = new FormData()
  form.append('name', name)
  await instance.post(`/api/profile`, form)
}

/// POST /api/profile/logout
export async function logout() {
  try {
    await instance.post(`/api/profile/logout`)
    store.commit('resetUser')
    router.push('/')
    return true
  } catch {
    return false
  }
}

/// POST /api/team/
export async function createTeam(detail: Omit<TeamDetailed, 'id'>) {
  await editTeam(-1, detail)
}

/// POST /api/team/<team_id>
export async function editTeam(
  teamId: number,
  { name, mod_name, desc, repo }: Omit<TeamDetailed, 'id'>
) {
  const form = new FormData()
  form.append('name', name)
  form.append('mod_name', mod_name)
  if (desc) {
    form.append('desc', desc)
  }
  if (repo) {
    form.append('repo', repo)
  }
  await instance.post(`/api/team${teamId > 0 ? `/${teamId}` : '/'}`, form)
}

/// POST /api/profile/team/invite
export async function refreshInviteCode(): Promise<string> {
  const response = await instance.post(`/api/profile/team/invite`)
  return response.data.invite as string
}

/// GET /api/team/name/<str:team_name>
export async function isTeamNameAvailable(teamName: string): Promise<boolean> {
  const response = await instance.get(`/api/team/name/${teamName}`)
  return response.data.result ?? response.data.resutl
}

/// GET /api/profile/qq
export async function getSelfQQState(): Promise<QQ | null> {
  try {
    const response = await instance.get('/api/profile/qq')
    return response.data
  } catch (e) {
    return null
  }
}

/// POST /api/profile/qq
export async function setQQ(qq: string) {
  const form = new FormData()
  form.append('qq', qq)
  await instance.post('/api/profile/qq', form)
}
